import { library } from "@fortawesome/fontawesome-svg-core";
import { faInstagram, faFacebookF, faYelp, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

library.add(faInstagram, faFacebookF, faYelp, faGoogle, faEnvelope);

// faXTwitter
